<template>
    <div class="init_content">
        <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
        <van-icon size="55" name="location-o" />
        <p>
            {{ tools.GetLanguageValue('public.app.未能获取定位信息') }}
        </p>
    </div>

</template>
<script>
import tools from "../../commons/tools.js"

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data () {
    return {
      tools: tools
    }
  },
  name: "App",

  components: {},
  mounted () {
    this.GetDistance()
  },
  methods: {
    // 获取定位
    GetDistance () {

    }
  }
}
</script>

<style lang="less" scoped>
.init_content {
    text-align: center;
}
</style>
